import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import useInactivityTimeout from "../components/hooks/useInactivityLogout";
import ErrorModal from "../components/modals/ErrorModal";

const InactivityHandler = () => {
  const { isAuthenticated, logout } = useAuth();
  const [alertText, setAlertText] = useState<AlertText>({
    name: "",
    desc: "",
    cta: "",
  });

  const { isWarningActive, resetTimer } = useInactivityTimeout({
    timeoutMinutes: 30,
    warningThresholdMinutes: 5,
    // timeoutMinutes: 0.2,
    // warningThresholdMinutes: 0.09,
    enabled: isAuthenticated,
    onWarning: () => {
      setAlertText({
        name: "Are you still there?",
        desc: "You will be logged out in 5 minutes due to inactivity",
        cta: "Stay Logged In",
      });
    },
    onTimeout: () => {
      logout();
      setAlertText({
        name: "Logged Out",
        desc: "You have been logged out due to inactivity",
        cta: "Log In Again",
      });
    },
  });

  return (
    <>
      {isWarningActive && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
          <ErrorModal
            onAccept={resetTimer}
            onClose={resetTimer}
            errorTitle={alertText.name}
            errorDescription={alertText.desc}
            btnTxt={alertText.cta}
          />
        </div>
      )}
    </>
  );
};

export default InactivityHandler;

type AlertText = {
  name: string | undefined;
  desc: string | undefined;
  cta: string | undefined;
};
